import { render, staticRenderFns } from "./NfeImportHistoryPage.vue?vue&type=template&id=d9856956&"
import script from "./NfeImportHistoryPage.vue?vue&type=script&lang=js&"
export * from "./NfeImportHistoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports